import { createSlice } from "@reduxjs/toolkit";

interface RootState {
    planetData :any,
    planetStatus:any,
    planetAccess :any
}

const initialState: RootState = {
    planetData :null,
    planetStatus:null,
    planetAccess :null
};

export const planetSlice :any = createSlice({
  name: "planet",
  initialState,
  reducers: {
    setPlanetData: (state: any, { payload }) => {
        state.planetData = payload;
      },
      setPlanetStatus: (state: any, { payload }) => {
        state.planetStatus = payload;
      },
    setPlanetAccess: (state: any, { payload }) => {
      state.planetAccess = payload;
    },
    
  },
  
});

export const {setPlanetData,setPlanetStatus,setPlanetAccess} = planetSlice.actions;

export const getPlanetDetails = (state: any) => state.planetReducer;



export default planetSlice.reducer;
